function ProcessHeading({ heading }) {
  return (
    <p>
      <strong>{heading}</strong>
    </p>
  );
}

export default ProcessHeading;
